import Axios from 'axios'
// import * as vod from './vod'
import * as main from './main'
import * as unauth from './unauth'

export const axios = {
  main: Axios.create({
    baseURL: process.env.REACT_APP_API_URL
  }),
  unauth: Axios.create({
    baseURL: process.env.REACT_APP_API_URL
  })
}

/**
 * @use ?${toQueryString({id: 1, type: "history"})}
 */
export const toQueryString = (data: Record<string, any>): string => {
  const copy: Record<string, string> = {}
  for (const key in data) copy[key] = data[key].toString()
  return new URLSearchParams(copy).toString()
}

export default {
  main,
  unauth
}